/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudArrowDownloadIcon16Solid = forwardRef('NetCloudArrowDownloadIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M.25 6.5a3.5 3.5 0 0 0 3.5 3.5h3.375v3.388L5.619 11.88A.875.875 0 0 0 4.38 13.12l2.293 2.293c.732.732 1.92.732 2.652 0l2.293-2.293a.875.875 0 1 0-1.238-1.238l-1.506 1.507V10h2.875a4 4 0 1 0-.84-7.912 4.252 4.252 0 0 0-7.737.959A3.501 3.501 0 0 0 .25 6.5ZM8.875 10V5.9a.875.875 0 1 0-1.75 0V10h1.75Z" })));
});
